import { render, staticRenderFns } from "./DlgAdDelete.vue?vue&type=template&id=79361ed6&scoped=true&"
import script from "./DlgAdDelete.vue?vue&type=script&lang=js&"
export * from "./DlgAdDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79361ed6",
  null
  
)

export default component.exports